import React, { useState } from "react";
import { func } from "prop-types";
import { connect } from "react-redux";

import { login, verifyEmail } from "../../helper/api";
import { isValidEmail } from "../../helper/utils";
import { setUserLoggedIn, setLoading } from "../../helper/actions";

import TextField from "../../atoms/textfield";
import Button from "../../atoms/button";
import ErrorView from "../../molecules/error-view";
import SuccessView from "../../molecules/success-view";

import "./login.m.css";

const VERIFY_EMAIL_MESSAGE = "Please do the Email Verification to complete the Registration!";

const Login = ({ setUserLoggedIn, navigateToPage, setLoading }) => {
  const [user, setUser] = useState({
    email: "",
    password: ""
  });
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const setData = e => {
    const userObj = { ...user };
    const fieldName = e.target.name;
    userObj[fieldName] = e.target.value;

    // If error has been set then remove it
    if (e.target.value && userObj[`${fieldName}Error`]) {
      userObj[`${fieldName}Error`] = "";
    }

    // If error is set remove it since data is changed
    if (error) {
      setError(null);
    }

    // If success message is set remove it since data is changed
    if (successMessage) {
      setSuccessMessage(null);
    }

    setUser(userObj);
  };

  const onSubmitClick = event => {
    event.preventDefault();

    if (validate()) {
      // true -> field errors, false - no fields errors
      return;
    }

    setLoading(true);
    const userObj = {
      email: user.email,
      password: user.password
    };

    login(userObj)
      .then(response => {
        if (response.member["verification-status"]) {
          // User email is verified
          setLoading(false);
          setUserLoggedIn(true, response.member);
          navigateToPage("/publications");
        } else {
          // User needs to validate the email account so send out an email to verify
          return verifyEmail(response.member.email).then(() => {
            setLoading(false);
            setSuccessMessage(VERIFY_EMAIL_MESSAGE);
          });
        }
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  };

  const validate = () => {
    const updatedUser = { ...user };
    let flag = false;

    if (!updatedUser.email) {
      updatedUser.emailError = "Email field cannot be left blank!";
      flag = true;
    } else if (!isValidEmail(updatedUser.email)) {
      updatedUser.emailError = "Invalid Email !!";
      flag = true;
    } else {
      updatedUser.emailError = "";
    }

    if (!updatedUser.password) {
      updatedUser.passwordError = "Password field cannot be left blank!";
      flag = true;
    } else {
      updatedUser.passwordError = "";
    }

    // If flag is true, there are field error's
    if (flag) {
      setUser(updatedUser); // update state with field errors
    }

    return flag;
  };

  return (
    <form onSubmit={onSubmitClick}>
      <div styleName="wrapper">
        <ErrorView error={error} closeClick={() => setError(null)} />
        <SuccessView text={successMessage} closeClick={() => setSuccessMessage(null)} />
        <TextField
          value={user.email}
          error={user.emailError}
          placeholder="who@areyou.com"
          label="Email"
          type="email"
          name="email"
          onChange={setData}
        />
        <TextField
          value={user.password}
          error={user.passwordError}
          placeholder="password"
          label="Password"
          type="password"
          name="password"
          onChange={setData}
        />
        <div styleName="actions-wrapper">
          <a href="forgot-password" styleName="link-button">
            FORGOT PASSWORD
          </a>
          <Button content="LOG IN" type="submit" />
        </div>
      </div>
    </form>
  );
};

Login.propTypes = {
  setUserLoggedIn: func,
  navigateToPage: func,
  setLoading: func
};

const mapDispatchToProps = dispatch => ({
  setUserLoggedIn: (isUserLoggedIn, user) => dispatch(setUserLoggedIn(isUserLoggedIn, user)),
  navigateToPage: url => global.app.navigateToPage(dispatch, url),
  setLoading: isLoading => dispatch(setLoading(isLoading))
});

export default connect(
  null,
  mapDispatchToProps
)(Login);
